import { FilterAlt } from '@mui/icons-material';
import { Badge, Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { ButtonIcons } from '@/components/ButtonIcons';
import { useDraftTimelogStore } from '@/features/draftTimelogs';
import { modalManagerStore } from '@/features/ModalManagerStore';
import { useTimeLogStore } from '@/pages/TimesheetsPage/model';

const FilterButton = observer(() => {
  const { filters } = useTimeLogStore();
  const { draftFilter } = useDraftTimelogStore();

  const hasActiveFilters = filters.taskKeys.selectedKeys.length > 0 || draftFilter !== 'all';

  const tooltipTitle = hasActiveFilters ? 'Фильтр (применён)' : 'Фильтр';

  return (
    <Tooltip title={tooltipTitle} arrow>
      <ButtonIcons
        isAccentColor={hasActiveFilters}
        onClick={() => modalManagerStore.open('filter')}
      >
        <Badge
          variant="dot"
          color="error"
          invisible={!hasActiveFilters}
          overlap="circular"
          sx={{
            '& .MuiBadge-badge': {
              top: 3.5,
              right: 1.5,
              minWidth: 5,
              width: 7,
              height: 7,
              padding: 0,
              borderRadius: '50%',
            },
          }}
        >
          <FilterAlt sx={{ width: '18px' }} />
        </Badge>
      </ButtonIcons>
    </Tooltip>
  );
});

export default FilterButton;
